<template>
    <div>
        <CartItem v-on:cart-remove-player="CartRemovePlayer" v-for="item in cartPlayers" v-bind:player="item"></CartItem>
        <p>Nonbre d'item acheter : <b>{{nbBuyItems}}</b></p>
        <p>Prix total : <b>{{totalPrice}}</b>M€</p>
    </div>
</template>

<script>
    import CartItem from "./CartItem";

    export default {
        name: "Cart",
        components: {
            CartItem,
        },
        props: {
            cartPlayers: Array
        },
        data: function () {
            return {
                nbBuyItems: 0,
                totalPrice: 0,
            }
        },
        methods: {
            CartRemovePlayer: function (aPlayer) {
                // On receptione et on reemaet l'event pour le niveau superieur
                this.$emit('cart-remove-player', aPlayer)
            }
        },
        watch: {
            cartPlayers(newCartPlayers) {
                // On m'est a jours les data a chaque modification de la liste des joueurs dans le paniers
                this.nbBuyItems = newCartPlayers.length;
                this.totalPrice = 0;
                newCartPlayers.forEach(aPlayer => {
                    this.totalPrice += aPlayer.price;
                });
            }
        }
    }
</script>

<style scoped>

</style>